import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import { AMOUNT_FROM_CCY } from 'apps/auth/constants/fieldsName';

import CountryPanelForExchange from './CountryPanelForExchange';

const ChangeAccountForExchangePopup = ({ popupRef = null, ...props }) => {
    const isFrom = props.field.name === AMOUNT_FROM_CCY;
    let getList = isFrom ? props.accountsFrom : props.availableAccountsTo;

    return (
        <ComplexPopup withoutButton textCenter popupRef={popupRef}>
            <ComplexPopupRow>
                <p>{isFrom ? props.exchangeMoneyFromTitle : props.exchangeMoneyToTitle}</p>
            </ComplexPopupRow>
            {getList.map((account, i) => (
                <CountryPanelForExchange
                    key={account + i}
                    account={account}
                    isFrom={isFrom}
                    currentCcy={props.current}
                    getCurrencyIcon={props.getCurrencyIcon}
                    onError={props.onError}
                    popupRef={popupRef}
                />
            ))}
        </ComplexPopup>
    );
};
ChangeAccountForExchangePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    getCurrencyIcon: PropTypes.func,
    onError: PropTypes.func,
    currencies: PropTypes.array,
    current: PropTypes.number,
    field: PropTypes.object,
};

const mapStateToProps = (state) => ({
    accountsFrom: state.extra.accountsFrom,
    exchangeMoneyFromTitle: state.messages.pageMessages.exchangeMoneyFromTitle,
    exchangeMoneyToTitle: state.messages.pageMessages.exchangeMoneyToTitle,
    availableAccountsTo: state.extra.availableAccountsTo,
});
export default connect(mapStateToProps, null)(ChangeAccountForExchangePopup);
